import { cn } from "@/lib/utils"

/**
 * The stock shadcn textarea, wearing `Input`'s shell.
 *
 * IT EXISTS BECAUSE THE ONBOARDING FORM HAD A COPY OF IT. The bio was a bare
 * `<textarea>` carrying `Input`'s class string pasted inline — which is fine until
 * `Input` changes and the bio keeps the old border, the old ring and the old
 * height. Two controls in one stack have to be one set of tokens or they drift
 * into looking like two apps.
 *
 * `field-sizing-content` GROWS IT AS SOMEBODY WRITES, up to `max-h`. A fixed
 * three-row box with an inner scrollbar hides the end of a short bio behind a
 * gesture, and a bio is 280 characters — small enough that the whole thing can
 * simply be on screen. `resize-none` because a drag handle is a desktop affordance
 * and does nothing under a thumb.
 */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-20 w-full rounded-lg border border-input bg-transparent px-3 py-2 text-[15px] shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 dark:bg-input/30",
        "resize-none",
        "focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
        "aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
